"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipe = exports.listenOnObject = void 0;
const popmotion_1 = require("popmotion");
const listenOnObject = (elementOrId, config) => {
    const obj = typeof elementOrId === 'string'
        ? document.getElementById(elementOrId)
        : elementOrId;
    if (!obj)
        throw new Error('Invalid element' + (typeof elementOrId === 'string' ? ' id' : '') + '.');
    obj.setAttribute('draggable', 'false');
    let down = false;
    const mouseDn = () => (down = true);
    document.addEventListener('mousedown', mouseDn);
    const mouseUp = () => (down = false);
    document.addEventListener('mouseup', mouseUp);
    let lastUpdate = 0;
    let x = 0;
    let y = 0;
    const mouseMv = (mouseMustBeDown) => (evt) => {
        if (mouseMustBeDown && !down)
            return;
        lastUpdate = Date.now();
        const rect = obj.getBoundingClientRect();
        x = Math.floor(1001 * (evt.offsetX / rect.width));
        y = Math.floor(1001 * (evt.offsetY / rect.height));
    };
    const mouseMv1 = mouseMv(true);
    const mouseMv2 = mouseMv(false);
    obj.addEventListener('mousemove', mouseMv1);
    obj.addEventListener('mousedown', mouseMv2);
    let oldX = x;
    let oldY = y;
    let oldActive = false;
    const handlers = [
        (x, y, active) => {
            oldX = x;
            oldY = y;
            oldActive = active;
        },
    ];
    const interval = setInterval(() => {
        if ((config === null || config === void 0 ? void 0 : config.disableInactive) !== true &&
            oldActive &&
            Date.now() - ((config === null || config === void 0 ? void 0 : config.inactive) || 2500) > lastUpdate &&
            !down)
            return handlers.forEach((handler) => __awaiter(void 0, void 0, void 0, function* () { return handler.call(null, x, y, false); }));
        if (x === oldX && y === oldY)
            return;
        handlers.forEach((handler) => __awaiter(void 0, void 0, void 0, function* () { return handler.call(null, x, y, true); }));
    }, (config === null || config === void 0 ? void 0 : config.interval) || 80);
    return {
        dispose() {
            clearInterval(interval);
            document.removeEventListener('mousedown', mouseDn);
            document.removeEventListener('mouseup', mouseUp);
            obj === null || obj === void 0 ? void 0 : obj.removeEventListener('mousemove', mouseMv1);
            obj === null || obj === void 0 ? void 0 : obj.removeEventListener('mousedown', mouseMv2);
            handlers.forEach((x) => __awaiter(this, void 0, void 0, function* () { var _a; return (_a = x.dispose) === null || _a === void 0 ? void 0 : _a.call(x); }));
        },
        onMove(handler) {
            handlers.push(handler);
        },
    };
};
exports.listenOnObject = listenOnObject;
const pipe = (elementOrId, config) => {
    const obj = typeof elementOrId === 'string'
        ? document.getElementById(elementOrId)
        : elementOrId;
    if (!obj)
        throw new Error('Invalid element' + (typeof elementOrId === 'string' ? ' id' : '') + '.');
    const size = (config === null || config === void 0 ? void 0 : config.size) || 25;
    const marker = (config === null || config === void 0 ? void 0 : config.customMarker) || document.createElement('div');
    if (!(config === null || config === void 0 ? void 0 : config.customMarker))
        Object.assign(marker.style, {
            width: size + 'px',
            height: size + 'px',
            borderRadius: '500px',
            backgroundColor: (config === null || config === void 0 ? void 0 : config.color) || 'black',
            transform: 'translateY(' + -(size / 2) + 'px)',
        });
    Object.assign(marker.style, {
        opacity: 0,
        position: 'absolute',
        zIndex: 5000,
        margin: 0,
    });
    marker.classList.add('image-pointer-marker');
    document.body.append(marker);
    let oldTop = 0;
    let oldLeft = 0;
    let animation;
    const handleFunction = function (x, y, active) {
        var _a, _b;
        marker.style.opacity = active ? '1' : '0';
        x = x / 1000;
        y = y / 1000;
        const rects = obj.getClientRects().item(0);
        const bound = obj.getBoundingClientRect();
        const markerBound = marker.getBoundingClientRect();
        const align = (config === null || config === void 0 ? void 0 : config.markerAlign) || 'center';
        const offsetLeft = align === 'right'
            ? markerBound.width
            : align === 'center'
                ? markerBound.width / 2
                : 0;
        const top = (bound.top + window.scrollY || window.pageYOffset) + y * rects.height;
        const left = (bound.left + window.scrollX || window.pageXOffset) +
            x * rects.width -
            offsetLeft;
        if (top !== oldTop || left !== oldLeft) {
            if (animation)
                animation.stop();
            animation = popmotion_1.animate({
                from: {
                    top: parseFloat((_a = marker.style.top) === null || _a === void 0 ? void 0 : _a.replace('px', '')) || 0,
                    left: parseFloat((_b = marker.style.left) === null || _b === void 0 ? void 0 : _b.replace('px', '')) || 0,
                },
                to: { top, left },
                ease: popmotion_1.cubicBezier(0.15, 0.49, 0.25, 1),
                duration: (config === null || config === void 0 ? void 0 : config.duration) || 500,
                onUpdate: latest => Object.assign(marker.style, {
                    top: latest.top + 'px',
                    left: latest.left + 'px',
                }),
            });
            oldTop = top;
            oldLeft = left;
        }
    };
    return Object.assign(handleFunction, {
        dispose() {
            document.body.removeChild(marker);
        },
    });
};
exports.pipe = pipe;
//# sourceMappingURL=index.js.map